import { createI18n } from "vue-i18n";
import { ref } from "vue";

function loadLocaleMessages() {
  const locales = require.context(
    "./locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key).default;
    }
  });
  return messages;
}

const i18n = createI18n({
  legacy: false, // enable composition API mode
  locale: ref("ar"), // set default locale using ref
  messages: loadLocaleMessages(),
});

export default i18n;